import { BrandedContent } from 'homepage/components/brandView/BrandedContent';
import { BrandSpaceContent } from 'homepage/components/brandView/BrandSpaceContent';
import { SECTION_TYPES } from 'homepage/enums/contentConstants';

interface IVerticalScrollTabProps {
  drawerName: string;
  firstVideo: boolean;
  heroes: any;
  setIsFirstVideo: (boolean) => void;
}

export const VerticalScrollTab = ({
  drawerName = 'brand',
  firstVideo,
  heroes,
  setIsFirstVideo,
}: IVerticalScrollTabProps) => {
  return (
    <>
      {heroes?.length === 1 &&
        heroes?.map((item, index) =>
          item?.type === SECTION_TYPES.SPACE_ARTICLE_SECTION ? (
            <BrandSpaceContent
              drawerName={drawerName}
              key={item?.id}
              section={item}
              isSingleSpaceBrandPage
            />
          ) : (
            <BrandedContent
              key={item?.id}
              drawerName={drawerName}
              {...item}
              index={index}
              firstVideo={firstVideo}
              setFirstVideo={setIsFirstVideo}
            />
          ),
        )}
    </>
  );
};
